import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { ListeningStatus } from "shared/config/constants";
import Logo from "../../assets/images/logo.svg";

import "./styles.scss";
import { appConfig } from "shared/app-config";
import { PiWaveformLight } from "react-icons/pi";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";
import { MdCallEnd, MdPhone } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
const createTitleProps = (title = "", position = "center") => ({
    title,
    position,
});

const TranscriptControl = ({
    conversationMode = false,
    listeningStatus,
    onDownloadTranscript,
    onConversationClick,
    onRecordingClick,
    onResetClick,
    conversation
}) => {
    let [btnTitleProps, setBtnTitleProps] = useState(createTitleProps());
   return (
        <div className="d-flex flex-column align-items-center">
               {/* Uncomment below code to enable transcript */}
            {(appConfig.DOWNLOAD_TRANSCRIPT_ENABLED === 'true' && conversation?.length) ? <Button
                    variant="link"
                    className="rounded-5"
                    onClick={onDownloadTranscript}
                >
                    Download transcript
                </Button> : ""}
            <img
                src={Logo}
                width={150}
                className="d-block d-lg-none" alt="download script"
            />
            <div className="pill-control position-relative">
                <Button
                    variant="light"
                    className={`pill-btn left ${conversationMode ? "clicked" : ""}`}
                    onClick={onConversationClick}
                    disabled={!conversation.length}
                    onMouseEnter={() => setBtnTitleProps(createTitleProps("Conversation", "left"))}
                    onMouseLeave={() => setBtnTitleProps(createTitleProps())}
                    aria-label="Conversation"
                >
                  <HiOutlineChatBubbleLeftRight size={"2rem"}/>
                </Button>

                <Button
                    variant="light"
                    className={`pill-btn center ${listeningStatus === ListeningStatus.Listening ? "pulsing stop-recording" : "start-recording"}`}
                    onClick={onRecordingClick}
                    disabled={listeningStatus === ListeningStatus.Preparing}
                    onMouseEnter={() => setBtnTitleProps(createTitleProps(listeningStatus === ListeningStatus.Listening ? "Stop Listening" : "Listen"))}
                    onMouseLeave={() => setBtnTitleProps(createTitleProps())}
                    aria-label="Start / Stop listening"
                >
                    { listeningStatus === ListeningStatus.Listening ? <RxCross1  size={"3rem"} fill={"white"} />: <PiWaveformLight size={"3rem"} fill={"white"}/>}
                </Button>
                <Button
                    variant="light"
                    className="pill-btn right"
                    onClick={onResetClick}
                    disabled={!conversation.length}
                    onMouseEnter={() => setBtnTitleProps(createTitleProps("End Conversation", "right"))}
                    onMouseLeave={() => setBtnTitleProps(createTitleProps())}
                    aria-label="End Conversation"
                >
                   <MdCallEnd  size={"3.5rem"} fill={"white"}/>
                </Button>
                <div className={`position-absolute btn-title ${btnTitleProps.position}`}>{btnTitleProps.title || (listeningStatus === ListeningStatus.Listening ? "Listening" : "")}</div>
            </div>
        </div>
    );
};

export default TranscriptControl;
